/* global mainScript */
import React, { useState, useRef, useEffect } from "react";
import styled from "@emotion/styled";
import PropTypes from "prop-types";

//style rules
import { Colors, Typography, Sizes } from "../styles";

const SortDropDown = ({ selectSortOption, selectedSortOption, isFood }) => {
	const [openDropDown, setOpenDropDown] = useState(false);

	const dropDownNode = useRef();

	const handleOutsideClick = (e) => {
		if (dropDownNode.current && !dropDownNode.current.contains(e.target)) {
			setOpenDropDown(!openDropDown);
		}
	};

	useEffect(() => {
		if (openDropDown) {
			document.addEventListener("mousedown", handleOutsideClick);
		}
		return () => {
			document.removeEventListener("mousedown", handleOutsideClick);
		};
	}, [openDropDown]);

	const toggleDropDown = () => {
		setOpenDropDown((currentValue) => !currentValue);
	};

	const sortOptions = isFood
	// adding conditional since food index does not sort by date
		? [
			{ name: "A - Z", slug: "alphabetically" },
			{ name: "Z - A", slug: "alphabetically-reverse" }]
		: [
			{ name: "Date", slug: "date" },
			{ name: "A - Z", slug: "alphabetically" },
			{ name: "Z - A", slug: "alphabetically-reverse" },];

	const renderSortOptions = () => {
		return (
			sortOptions &&
			sortOptions.length > 0 &&
			sortOptions.map((option) => {
				return (
					<DropDownListItem
						key={option.slug}
						onClick={() => selectSortOption(option.slug)}
					>
						<CheckboxLabel>{option.name}</CheckboxLabel>
						<input
							type={"checkbox"}
							onChange={() => {}}
							checked={selectedSortOption && selectedSortOption === option.slug}
						/>
					</DropDownListItem>
				);
			})
		);
	};

	return (
		<DropDownContainer ref={dropDownNode}>
			<DropDownTrigger onClick={toggleDropDown} onKeyPress={toggleDropDown}>
				{"Sort by"}
			</DropDownTrigger>
			{openDropDown && <DropDownList>{renderSortOptions()}</DropDownList>}
		</DropDownContainer>
	);
};

export default SortDropDown;

SortDropDown.propTypes = {
	DropDownLabel: PropTypes.string,
	selectSortOption: PropTypes.func,
	selectedSortOption: PropTypes.string,
	isFood: PropTypes.bool,
};

// fake centering using the top value
const DropDownContainer = styled.div`
	position: relative;
	top: 5px;
	padding-top: 2rem;

	@media only screen and (min-width: ${Sizes.screens.large}) {
		padding-top: 0;
	}
`;

const DropDownTrigger = styled.button`
	padding: 1.3rem 1.5rem;
	text-transform: capitalize;
	border: 1px solid ${Colors.base.black};
	font-weight: 700;
	font-size: 1.3rem;
	line-height: 1.6rem;
	border-radius: 10px;
	cursor: pointer;
	display: flex;
	gap: 1.1rem;
	height: unset;
	background: none;
	transition: all 0.5s;

	&::after {
		content: url(${mainScript.assetPath +
		"images/svg/icons/icon-down-arrow.svg"});
	}
`;
const DropDownList = styled.ul`
	display: flex;
	flex-direction: column;
	gap: 1.6rem;
	margin: 0;
	padding: 1.6rem 1.5rem 2rem;
	width: 100%;
	position: absolute;
	top: 72px;
	background-color: ${Colors.base.white};
	border: 1px solid ${Colors.base.black};
	border-radius: 10px;
	z-index: 1;

	@media only screen and (min-width: ${Sizes.screens.large}) {
		top: 50px;
	}
`;

const DropDownListItem = styled.li`
	margin: 0;
	padding: 0;
	list-style: none;
	display: flex;
	flex-direction: row;
	justify-content: space-between;

	input[type="checkbox"] {
		min-width: 15px;
		height: 15px;
		margin: 0;
		border-radius: 3px;

		&:before {
			content: "✓";
			display: block;
			transform: translateX(-100%);
		}

		&:checked::before {
			transform: translateY(-14%);
		}
	}
`;

const CheckboxLabel = styled.label`
	font-size: 1rem;
	line-height: 1.6rem;
	font-weight: ${Typography.fontWeight.regular};
`;
